const Moment = require('moment');
require('moment-timezone');

const enLocale = Moment.localeData('en');
Moment.defineLocale('ja-balus', {
    parentLocale: 'ja',
    meridiem: enLocale.meridiem,
    _meridiemParse: enLocale._meridiemParse,
    isPM: enLocale.isPM,
});
Moment.locale('ja-balus');
Moment.locale('ja-balus');

module.exports.setLocale = function(locale) {
    if(locale == 'ja') {
        return Moment.locale('ja-balus');
    }

    return Moment.locale(locale);
};

module.exports.setTimezone = function(tz) {
    return Moment.tz.setDefault(tz);
};



// WEBPACK FOOTER //
// ./balus/infra/moment/config.js